/* eslint-disable camelcase */
import {FC, useState} from 'react';
import {useDispatch} from 'react-redux';

import {FoodDiningShape} from '@stencil/hotels-cg-reducer/src/details/types';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import useDetailsScrollGa from '@stencil/use-details-scroll-ga';

import * as S from './MultiRestaurentUI.styles';

// Components
import MultiRestaurentCard from './MultiRestaurentCard/MultiRestaurentCard';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';

interface MultiRestaurentUIProps {
  header?: string;
  fnd: FoodDiningShape;
  ambienceRating?;
  tasteRating?;
}

const MultiRestaurentUI: FC<MultiRestaurentUIProps> = ({
  header = 'Food & Dining',
  fnd,
  ambienceRating,
  tasteRating,
}) => {
  const dispatch = useDispatch();
  const {foodWatcherRef} = useDetailsScrollGa();

  const {restaurants} = fnd;
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(0);

  const tasteRatingFormatted = tasteRating > 0 && Math.round(tasteRating * 10) / 10;

  const handleAccordionClick = accordionIndex => {
    setActiveAccordionIndex(accordionIndex);
  };

  const entireCardClickedHandler = () => {
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.MultiRestraunt}_Clicked`,
          type: omnitureConfig.ctaType.Card,
          componentName: DetailsPageComponents.MultiRestraunt,
          destination: '',
        },
      }),
    );
  };

  return (
    <>
      <S.FoodDiningWrapper
        ref={foodWatcherRef}
        id={detailsNavigationIds.foodDining}
        onClick={entireCardClickedHandler}
      >
        <S.DiningHeader>{header}</S.DiningHeader>
        <S.ContentWrap>
          {(!!ambienceRating || !!tasteRating) && (
            <S.FoodRatingWrapper>
              {ambienceRating > 0 && (
                <li>
                  <S.RatingSpan rating={ambienceRating}>
                    <S.RatingNumberSpan>{ambienceRating}</S.RatingNumberSpan>/5
                  </S.RatingSpan>
                  <S.AmbienceSpan>Ambience</S.AmbienceSpan>
                </li>
              )}
              {tasteRating > 0 && (
                <li>
                  <S.RatingSpan rating={tasteRatingFormatted}>
                    <S.RatingNumberSpan>{tasteRatingFormatted}</S.RatingNumberSpan>/5
                  </S.RatingSpan>
                  <S.AmbienceSpan>Taste</S.AmbienceSpan>
                </li>
              )}
            </S.FoodRatingWrapper>
          )}
          {restaurants.map((item, index) => {
            return (
              <MultiRestaurentCard
                data={item}
                key={index.toString()}
                index={index}
                activeAccordionIndex={activeAccordionIndex}
                setExpandedAccordion={handleAccordionClick}
              />
            );
          })}
        </S.ContentWrap>
      </S.FoodDiningWrapper>
    </>
  );
};

export default MultiRestaurentUI;
